export const HERO_CONSTANTS = {
  button: {
    label: "Start Free Trial",
    link: "#contact-us",
    btn2: {
      label: "Schedule A Demo",
      link: "#contact-us",
    },
  },
  content: "Open-source cloud computing platform for seamless resource orchestration",
  title: "OneMind's Managed OpenStack (MOST)",
};
